const sessionDate = (value) => {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const date = new Date(`${value}T12:00:00Z`);
  if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== value) return null;
  return new Intl.DateTimeFormat(undefined, {
    dateStyle: 'medium', timeZone: 'UTC',
  }).format(date);
};

export const nextMarketCheckLabel = (archived, desiredState, nextExpectedSessionDate, marketSession) => {
  if (archived) return 'None · archived';
  if (desiredState === 'pause') return 'Paused';
  if (desiredState === 'stop') return 'Not scheduled · checks ended';
  if (desiredState !== 'run') return 'Schedule unavailable';
  // After today's close, the backend's expected-session date advances before
  // the worker may have checked that just-completed session. Do not call the
  // following session the next check until worker timing is exposed directly.
  if (marketSession === 'closed') return 'Market closed · exact check time unavailable';
  const date = sessionDate(nextExpectedSessionDate);
  return date ? `After the ${date} market session completes` : 'Schedule unavailable';
};
